exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js!./base.css"), "");
exports.i(require("-!./../../node_modules/css-loader/index.js!./nprogress.css"), "");

// module
exports.push([module.id, "body{overflow-y:scroll!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!./client/css/index.css
 ** module id = 568
 ** module chunks = 0
 **/